import React, { createContext, useContext } from "react";
import useSpeechSynthesis from "./useSpeechSynthesis";

const SpeechSynthesisContext = createContext(null);

export function SpeechSynthesisProvider({ children }) {
  const value = useSpeechSynthesis();

  return (
    <SpeechSynthesisContext.Provider value={value}>
      {children}
    </SpeechSynthesisContext.Provider>
  );
}

export function useSpeechSynthesisContext() {
  const context = useContext(SpeechSynthesisContext);
  if (!context) {
    throw new Error(
      "useSpeechSynthesisContext must be used within SpeechSynthesisProvider",
    );
  }
  return context;
}
